import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import React from 'react'
import { useMeetingStore } from '../../../store/meeting.store'
import { useSocketsContext } from '../../../contexts/sockets.context'
import { toast } from 'react-toastify'
import { Box, Button, CircularProgress, TextField, Tooltip, useTheme } from '@mui/material'
import api from '../../../service/api'
import { useParams } from 'react-router-dom'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'

const initialValues = {
    name: "",
    email: "",
    passkey: ""
}

const validationSchema = Yup.object().shape( {
    email: Yup.string().email( "Enter a valid E-mail" ).required( "E-mail is required" ),
    passkey: Yup.string().required( "Passkey is required" ).matches( /^[A-Z0-9]{8}$/, "Passkey must be 8 character long with only numbers and uppercase letters" )
} )

const MeetingJoinForm = ( { joinChannel, joining, fields = ["name", "email", "passkey"] } ) => {

    // const {  connectToSocketServer } = useSocketsContext()
    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()
    const { palette, border } = useTheme()
    const { meeting_id } = useParams()

    const MeetingStore = useMeetingStore()


    const askToJoin = async ( values ) => {
        try {
            const email = values.email
            const name = values.name
            const passkey = values.passkey

            for ( const field of fields ) {
                if ( !values[field] )
                    return toast( "Provide all the details to join the meeting" )

            }

            MeetingStore.setLocalUserDetails( { user_id: email, room_id: meeting_id, name: name, email: email, type: "local-client" } )
            const { data: { data: { token, agoraChannelToken, agoraChannelShareToken } } } = await api.onlineMeetings.getMeetingAccessToken( meeting_id, { user_id: email, room_id: meeting_id, name: name, email: email, meeting_passkey: passkey } )
            sessionStorage.setItem( 'meetingAccessToken', JSON.stringify( { meeting_id: meeting_id, token, agoraChannelToken, agoraChannelShareToken } ) )
            MeetingStore.setCurrentMeetingAccessDetails( { hasAccess: true } )
            await OnlineSessionSocketStore.connect( meeting_id, email )
            joinChannel()
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to join meeting! please try again." )
        }
    }

    return (
        <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={askToJoin} >
            {( { errors, setFieldValue } ) => {
                return (
                    <Form>
                        <Box display="flex" flexDirection="column" gap="20px" alignItems="center">
                            <Box display="flex" gap="10px" flexWrap="wrap" justifyContent="center" >
                                {fields.includes( "name" ) && <Tooltip placement='top' disableInteractive title="Enter your name" >
                                    <Box component="span">
                                        <Field name="name" as={TextField} sx={{ ":focus": { border: "1px solid red" } }} variant='standard' size='large' placeholder="What is your name?" slotProps={{ htmlInput: { sx: { padding: "10px", borderRadius: "40px", border: Boolean( errors.name ) ? `2px solid ${palette.error.main}` : border[1], ":focus": { borderColor: palette.secondary.main, borderWidth: "2px" } } }, input: { disableUnderline: true } }} />
                                    </Box>
                                </Tooltip>}
                                {fields.includes( "email" ) && <Tooltip placement='top' disableInteractive title={Boolean( errors.email ) ? errors.email : ""} >
                                    <Box component="span">
                                        <Field name="email" as={TextField} sx={{ ":focus": { border: "1px solid red" } }} variant='standard' size='large' placeholder="What is your E-mail?" slotProps={{ htmlInput: { sx: { padding: "10px", borderRadius: "40px", border: Boolean( errors.email ) ? `2px solid ${palette.error.main}` : border[1], ":focus": { borderColor: palette.secondary.main, borderWidth: "2px" } } }, input: { disableUnderline: true } }} />
                                    </Box>
                                </Tooltip>}
                                {fields.includes( "passkey" ) && <Tooltip placement='top' disableInteractive title={Boolean( errors.passkey ) ? errors.passkey : ""} >
                                    <Box component="span">
                                        <Field name="passkey" onChange={e => setFieldValue( 'passkey', e.target.value?.toUpperCase() )} as={TextField} sx={{ ":focus": { border: "1px solid red" } }} variant='standard' size='large' placeholder="Meeting passkey?" slotProps={{ htmlInput: { sx: { padding: "10px", borderRadius: "10px", border: Boolean( errors.passkey ) ? `2px solid ${palette.error.main}` : border[1], textAlign: "center", fontSize: "24px", ":focus": { borderColor: palette.secondary.main, borderWidth: "2px" } } }, input: { disableUnderline: true } }} />
                                    </Box>
                                </Tooltip>}
                            </Box>
                            <Button type='submit' disabled={joining} startIcon={joining && <CircularProgress size={20} />} variant='contained' size='large' disableElevation sx={{ paddingY: "10px", borderRadius: "40px" }} >Join</Button>
                        </Box>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default MeetingJoinForm
